import { BaseReportFields } from '@modules/missions/keaz/types'
import { AgentumReportWithRelations } from '@api/generated'
import { formatDate } from '@modules/missions/keaz/utils/date'

interface TasksTableCellChangingDateProps {
  task: AgentumReportWithRelations
}

export function TasksTableCellChangingDate({ task }: TasksTableCellChangingDateProps) {
  if (!task[BaseReportFields.timestamp]) {
    return <></>
  }

  return <>{formatDate(task[BaseReportFields.timestamp])}</>
}
